// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_RefundRecebimentoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payments/links/refund_recebimento/{recebimento_id}
 *
 * Refunds a specific recebimento/charge using the charge ID
 * stored in recebimento_id_externo.
 */
import { registerContract } from './validate'

export interface SubaccountsLinks_RefundRecebimentoInput {
value?: number
description?: string
}

registerContract('SubaccountsLinks_RefundRecebimentoInput', {
  value:       { type: 'number',  required: false },
  description: { type: 'string',  required: false },
})
